const fs = require('fs')
import { readFileSync } from 'fs';
import m from 'mithril';
import {trans, has_permission, has_role} from "./helpers";


const ApproveIcon = readFileSync(__dirname + "/../public/imgs/icons/check-solid.svg", "utf8");
const RejectIcon = readFileSync(__dirname + "/../public/imgs/icons/times-solid.svg", "utf8");
const EditIcon = readFileSync(__dirname + "/../public/imgs/icons/pen-solid.svg", "utf8");
const EyeIcon = readFileSync(__dirname + "/../public/imgs/icons/eye-solid.svg", "utf8");
const TrashIcon = readFileSync(__dirname + "/../public/imgs/icons/trash-solid.svg", "utf8");

let challenges_state = {
    term : null,
    loading: false,
    load_more: false,
    page: 1,
    limit:10,
    timeout: null,
    search_parameters: {},
    challenges : {
        status: 3,
        list: [],
    },
    id_challenge_observed: null
}

class Searcher {
    view() {
        return [
            m('div.ijf-form', [
                m('div.line', [
                    m('div.line-element', [
                        m('label', trans('common.search')),
                        m('input', {
                            placeholder: trans('challenge.select_challenge_placeholder'),
                            type: 'text',
                            onkeyup: e => update_term(e)
                        }),
                    ]),
                    m('div.line-element', [
                        m('label', trans('common.status')),
                        m('select', {
                                onchange : e => {
                                    challenges_state.challenges.status = e.target.value;
                                    query_challenges();
                                },
                                value : challenges_state.challenges.status || 0
                            }, [
                                m('option', {
                                    value : 0,
                                }, trans('common.all')),
                                m('option', {
                                    value : 1,
                                }, trans('common.approved')),
                                m('option', {
                                    value : 2,
                                }, trans('common.rejected')),
                                m('option', {
                                    value : 3,
                                }, trans('common.not_approved')),
                                m('option', {
                                    value : 4,
                                }, trans('common.deleted')),
                                m('option', {
                                    value : 5,
                                }, trans('common.public_challenges_request'))
                            ]
                        ),
                    ]),
                ]),
            ]),


        ];
    }
}

class Challenges {

    oninit(vnode) {
        get_challenges();
    }

    load_more(e) {
        challenges_state.page = challenges_state.page+1;
        challenges_state.load_more = false;
        get_challenges(false);
    }

    view(){
        // let _class = '.table.table--stripped.table--dark-theme.table--overflow';
        let _class = '.table.table--dark-theme.table--overflow';

        let is_public_request = (challenges_state.challenges.status == 5);

        return m('.admin-overview', [

            m(Searcher),
            m('.table-scroll-wrapper', [
                m('table' + _class, [
                    m('thead',
                        m('tr', [
                            m('th', trans('challenge.title')),
                            m('th', trans('exercises.user')),
                            m('th', trans('exercises.status')),
                            m('th', trans('exercises.created_at')),
                            m('th', ''),
                        ])),
                    m('tbody', challenges_state.challenges.list.map(_e => {

                        let status = 0;
                        //let is_rejected = 0;

                        if(_e.rejected == 1) {
                            status = trans('common.rejected');
                        } else if(_e.validated == 1) {
                            status = trans('common.approved');
                        } else {
                            status =  trans('common.not_approved');
                        }

                        return [
                            m('tr', [
                                m('td', m('a.link-text', { href: '/challenge/view/' + _e.slug, target: '_blank' }, _e.title)),
                                m('td', [
                                    m('span', _e.last_name + ' ' + _e.first_name),
                                    // m('br'),
                                    // m('span', _e.email)
                                ]),
                                m('td', status),
                                m('td', _e.inserted_at),

                               // _e.deleted_at &&
                               //  m('td', new Date(_e.deleted_at).toLocaleDateString("sl-SI")),
                               
                               (!_e.deleted_at && ! is_public_request) &&
                                m('td.buttons',
                                    [
                                        m('.btn.btn--orange.btn--small.btn--icon-only', {
                                            title: trans('common.titles.additional_info'),
                                            onclick: e => {
                                                challenges_state.id_challenge_observed = challenges_state.id_challenge_observed == _e.id_challenge ? null : _e.id_challenge;
                                            }
                                        }, m.trust(EyeIcon)),
                                        m('.btn.btn--confirm-green.btn--small.btn--icon-only', {
                                            title: trans('common.titles.validate'),
                                            onclick: e => updateChallenge(_e.id_challenge, 'confirm'),
                                        }, m.trust(ApproveIcon)),
                                        m('.btn.btn--red.btn--small.btn--icon-only', {
                                            title: trans('common.titles.reject'),
                                            onclick: e => updateChallenge(_e.id_challenge, 'reject')
                                        }, m.trust(RejectIcon)),
                                        m('a.btn.btn--main.btn--small.btn--icon-only', {
                                            title: trans('common.titles.edit'),
                                            href: '/challenge/edit/' + _e.id_challenge
                                        }, m.trust(EditIcon)), 
                                        m('.btn.btn--red.btn--small.btn--icon-only', {
                                            title: trans('common.titles.delete'),
                                            onclick: e => {
                                                delete_challenge(_e.id_challenge)
                                            }
                                        }, m.trust(TrashIcon)),
                                    ]
                                ),

                                (!_e.deleted_at && is_public_request) &&
                                m('td.buttons',
                                    [
                                        m('.btn.btn--orange.btn--small.btn--icon-only', {
                                            title: trans('common.titles.additional_info'),
                                            onclick: e => {
                                                challenges_state.id_challenge_observed = challenges_state.id_challenge_observed == _e.id_challenge ? null : _e.id_challenge;
                                            }
                                        }, m.trust(EyeIcon)),
                                        m('.btn.btn--confirm-green.btn--small.btn--icon-only', {
                                            title: trans('common.titles.approve_request'),
                                            onclick: e => approvePublicRequest(_e.id_challenge),
                                        }, m.trust(ApproveIcon)),
                                        m('a.btn.btn--main.btn--small.btn--icon-only', {
                                            title: trans('common.titles.edit'),
                                            href: '/challenge/edit/' + _e.id_challenge
                                        }, m.trust(EditIcon)), 
                                        m('.btn.btn--red.btn--small.btn--icon-only', {
                                            title: trans('common.titles.delete'),
                                            onclick: e => {
                                                delete_challenge(_e.id_challenge)
                                            }
                                        }, m.trust(TrashIcon)),
                                    ]
                                ),
                            ]),

                            (challenges_state.id_challenge_observed && challenges_state.id_challenge_observed == _e.id_challenge) &&
                            m('tr.additional-info-tr', [
                                m('td', {colspan: 5}, [
                                    m('table.additional-info-subtable', [
                                        m('tbody', [
                                            m('tr', [
                                                m('td', m('b', trans('challenge.creator_email') + ': ')),
                                                m('td', _e.email),
                                            ]),
                                            m('tr', [
                                                m('td', m('b', trans('challenge.form.age_groups') + ': ')),
                                                m('td', _e.group_items.length > 0 ? _e.group_items.map(_g => _g.title).join(', ') : trans('common.all_age_groups')),
                                            ]),
                                            m('tr', [
                                                m('td', m('b', trans('challenge.form.sports') + ': ')),
                                                m('td', _e.sports.length > 0 ? _e.sports.map(_s => _s.title).join(', ') : trans('common.all_sports')),
                                            ]),
                                            m('tr', [
                                                m('td', m('b', trans('challenge.form.organizations') + ': ')),
                                                m('td', _e.organizations.length > 0 ? _e.organizations.map(_o => _o.title).join(', ') : trans('common.all_organizations')),
                                            ]),
                                            m('tr', [
                                                m('td', m('b', trans('challenge.form.roles') + ': ')),
                                                m('td', _e.roles.length > 0 ? _e.roles.map(_r => _r.title).join(', ') : trans('common.all_roles')),
                                            ]),
                                        ])
                                    ])
                                ])
                            ])
                        ];
                    })),
                ]),
            ]),

            (challenges_state.load_more && !challenges_state.loading) &&
            m('.btn.btn--small.btn--full-width.load-more', { 
                onclick: e => this.load_more(e)
            }, trans('common.load_more')),

            (challenges_state.loading) &&
            m('.general-loader', '')
            // m('.loading-text', trans('challenge.loading') + '...')
        ]);
    };
}

function updateChallenge(id_challenge, type) {
    let data = {};

    if(type == 'confirm') {
        data['validated'] = 1
        data['rejected'] = 0
    } else if(type == 'reject') {
        data['validated'] = 0
        data['rejected'] = 1
    }

    data['id_challenge'] = id_challenge;

    m.request({
        method: "POST",
        url: "/api/challenge",
        responseType: "json",
        body: data
    }).then(function(data) {
        if (data) {
            get_challenges()
        } else {
            alert("ERROR!");
        }
    });

}

function update_term(e) {
    challenges_state.search_parameters.query = e.target.value;

    query_challenges()
}

function query_challenges() {

    clearTimeout(challenges_state.timeout);

    challenges_state.timeout = setTimeout(e => {
        challenges_state.page = 1;
        challenges_state.load_more = false;
        get_challenges();
    }, 500);
}

function get_challenges(override=true) {
    challenges_state.loading = true;
    challenges_state.load_more = false;

    if(!challenges_state.search_parameters.query)
        challenges_state.search_parameters.query = '';

    m.redraw();


    let query_parameters = 'visibility=all' +
                           '&page=' + challenges_state.page +
                           '&limit=' + challenges_state.limit +
                           '&part=organizations,sports,roles,group_items' +
                           '&order_by=inserted_at|desc' +
                           '&query=' + challenges_state.search_parameters.query;

    let query_status = challenges_state.challenges.status;

    // show deleted
    if (challenges_state.challenges.status == 4) {
        query_status = 0;
        query_parameters += '&only_deleted=1';
    }

    query_parameters += '&status=' + query_status;

    m.request('/api/challenge?' + query_parameters)
        .then(d => {
            if (d.length > challenges_state.limit) {
                challenges_state.load_more = true;
                d = d.slice(0, challenges_state.limit);
            }

            d = d.map(challenge => {
                challenge['inserted_at'] = new Date(challenge['inserted_at']).toLocaleDateString("sl-SI");
                return challenge;
            });            

            if (override) {
                challenges_state.challenges.list = d;                
            } else {
                challenges_state.challenges.list = challenges_state.challenges.list.concat(d);
            }

            challenges_state.loading = false;

            m.redraw();
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function delete_challenge(id_challenge) {
    m.request('/api/challenge?id_challenge='+id_challenge)
    .then(challenge => {
        let num_entries = challenge.total_users*1;

        let confirm_delete_msg = trans('challenge.confirm_delete_warning') + '\n';

        confirm_delete_msg += trans('challenge.confirm_delete_number_of_entries') + ' ' + num_entries + '\n\n';
        confirm_delete_msg += trans('challenge.confirm_delete_text');
        
        let confirm_delete = confirm(confirm_delete_msg);
        
        if (!confirm_delete) 
            return

        m.request({
            method: "POST",
            url: '/api/challenge/delete',
            responseType: "json",
            body: {
                id_challenge: id_challenge
            }
         })
        .then(d => {
            get_challenges();
         })
        .catch(e => {
            alert(trans('common.something_went_wrong'))
        })
    })
    .catch(e => {
        alert(trans('common.something_went_wrong'))
    })
}

function approvePublicRequest(id_challenge) {
    let confirm_message = trans('challenge.confirm_approve_request_public_title') + '\n\n';
    confirm_message += trans('challenge.confirm_approve_request_public_text');

    if (!confirm(confirm_message)) {
        return;
    }

    m.request({
        method: "POST",
        url: '/api/challenge/approve_public_request',
        responseType: "json",
        body: {
            id_challenge: id_challenge
        }
     })
    .then(d => {
        get_challenges();
     })
    .catch(e => {
        alert(trans('common.something_went_wrong'))
    })
}

function init(rootElement, id_exercise, is_admin) {

    if (!rootElement) {
        return;
    }

    m.mount(rootElement, Challenges);
}

export default init;